
export default function ComparisonHero() {
  return (
    <section className="pt-28 sm:pt-32 pb-12 sm:pb-16 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto text-center">
        <span className="inline-block px-4 py-1.5 bg-primary/10 text-primary text-xs font-semibold rounded-full mb-6">
          COMPARE OS PLANOS
        </span>
        
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
          Escolha o Plano Ideal
          <span className="block text-primary mt-2">Para o Seu Negócio</span>
        </h1>
        
        <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto mb-8">
          Compare as funcionalidades dos planos Start e Scale e descubra qual se encaixa 
          melhor nas necessidades da sua empresa. Ambos com 7 dias de garantia.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-500">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-check-line text-accent-green text-lg"></i>
            </div>
            <span>7 dias de garantia</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-bank-card-line text-accent-green text-lg"></i>
            </div>
            <span>Cancele quando quiser</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-customer-service-2-line text-accent-green text-lg"></i>
            </div>
            <span>Suporte dedicado</span>
          </div>
        </div>
      </div>
    </section>
  );
}
